import http from '~/common/http'
import Storage from '~/common/storage'
import Time from '~/common/time'
import store from '~/store/index'
import router from '~/common/router'
import {APP} from "~/config/app";
import getters from "~/store/getters";

const Model = {
    username: "",
    password: ""
}

const CACHE_KEY = 'ACCOUNT';

const LOGIN_URL = '/login';

/**
 * 账号接口服务类
 */
export default {
    
    login(username, password) {

        // 操作前先清空登录信息相关缓存
        this.clearCache();

        return this.getAccessToken(username, password).then(res => {
            if (res.code == 0 && res.data) {
                let data = res.data;
                this.setCache({
                    id: data.id,
                    name: data.name,
                    mobile: data.mobile,
                    email: data.email,
                    access_token: data.access_token,
                    duration: data.duration,
                    timestamp: data.timestamp,
                    role_id: data.role_id,
                    cache: data.cache
                });
                return true;
            } else {
                return false;
            }
        });
    },

    /**
     * 获取AccessToken
     * @param {*} username 
     * @param {*} password 
     */
    getAccessToken(username, password) {
        return http.post('/api/account/token', {
            username: username,
            password: password
        });
    },

    /**
     * 远程得到当前登录的用户信息
     */
    getInfo() {
        return http.get('/api/account/info');
    },

    /**
     * 刷新 AccessToken
     */
    refreshAccessToken() {
        return http.put('/api/account/refresh').then(res => {
            if (res && res.code == 0) {
                this.setCache(res.data);
                return true;
            } else {
                return false;
            }
        }).catch(err => {
            console.log("刷新TOKEN异常：", err);
            return false;
        });
    },

    /**
     * 注销登录
     * @param {*} token 
     */
    logout(token) {
        return http.post('/api/account/logout').then(() => {
            // 登出后删除缓存中的身份信息
            Storage.remove(CACHE_KEY);
        });
    },

    getCacheKey() {
        return CACHE_KEY;
    },

    /**
     * 设置账号信息本地缓存
     * @param {*} user 
     */
    setCache(user) {
        let duration = user.duration ? user.duration : 0;
        return Storage.set(this.getCacheKey(), user, duration);
    },

    /**
     * 获取账号信息缓存
     */
    getCache() {
        //return  Storage.get(this.getCacheKey());
        //console.log("缓存中的账号数据：", Storage.getCacheData(this.getCacheKey()));
        return Storage.getCacheData(this.getCacheKey());
    },

    /**
     * 清空保存用户身份信息的前端缓存
     */
    clearCache() {
        return Storage.remove(this.getCacheKey());
    },

    /**
     * 从缓存中获取用户身份信息
     * @return object
     */
    getIdentityByCache() {
        let cache = this.getCache();
        if (cache) {
            return cache;
        } else {
            return;
        }
    },

    /**
     * 通过缓存获取AccessToken
     * @return string
     */
    getAccessTokenByCache() {
        let cache = this.getIdentityByCache();
        if (cache && cache.access_token) {
            return cache.access_token;
        } else {
            return '';
        }
    },

    /**
     * 判断是否已登录
     */
    isGuest() {
        let identity = this.getIdentityByCache();
        if (!identity) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * 判断Token是否已过期
     */
    isExpire() {
        let identity = this.getIdentityByCache();
        if (identity && identity.timestamp > 0 && identity.duration > 0) {
            let currentTime = Time.now();
            let diffTime = currentTime - identity.timestamp;
            // 已经过期
            if (diffTime > identity.duration) {
                return true;
            }
        }
        return false;
    },

    /**
     * 验证当前登录用户是否有权限可以访问
     * @param route
     * @returns {boolean}
     */
    can(route) {

        if(!APP.enableAuthPermission){
            return true
        }
        let allowRoutes = store.getters.allow_routes;
        if (allowRoutes.length > 0 && allowRoutes.indexOf(route) !== -1) {
            return true;
        }
        return false;
    },
    /**
     * 菜单/路由访问：Vue path 通过后，若配置了 meta.auth 还需具备对应接口权限
     * @param path
     * @param meta
     * @returns {boolean}
     */
    canAccess(path, meta) {
        if (!this.can(path)) {
            return false;
        }
        if (meta && meta.auth && !this.can(meta.auth)) {
            return false;
        }
        return true;
    },

    /**
     * 得到第一条被允许的路由
     * @returns {string}
     */
    getFirstAllowRoute() {

        let data = router.options.routes;
        let routes = [];

        if (data.length > 0) {
            data.forEach(item => {
                if (!item.hidden && item.children && item.children.length > 0) {
                    item.children.forEach(child => {
                        let path = item.path + '/' + child.path;
                        if (this.canAccess(path, child.meta) && !child.hidden) {
                            routes.push(path);
                        }
                    });
                }
            });
        }

        return routes.length > 0 ? routes[0] : '';
    },

    /**
     * 获取账户登录默认路由
     * @returns {*}
     */
    getDefaultRoute() {
        let route = this.getFirstAllowRoute();
        if (route == '') {
            return '/403';
        }
        return route;
    },

    /**
     * 切换账号-只支持超管操作
     * @param {*} username 
     * @param {*} password 
     */
    getNewAccessToken(id) {
        return http.get('/api/account/switch-accounts', {
            params: {
                id: id
            }
        });
    },


    /**
     * 切换账号-只支持超管操作
     * @param {*} username 
     * @param {*} password 
     */
    switchAccounts(id) {
        return this.getNewAccessToken(id).then(res => {
            if (res.code == 0 && res.data) {
                // 操作前先清空登录信息相关缓存
                this.clearCache();
                let data = res.data;
                this.setCache({
                    id: data.id,
                    name: data.name,
                    mobile: data.mobile,
                    email: data.email,
                    access_token: data.access_token,
                    duration: data.duration,
                    timestamp: data.timestamp,
                    role_id:data.role_id,
                    cache: data.cache
                });
                // // 如果过期尝试刷新token以便保持登录 只会尝试一次不能刷新成功将被踢下线
                // store.dispatch('refreshToken').then(res => {
                //     this.checkIdentity(to, from, next);
                // })
                return true;
            } else {
                return false;
            }
        });
    },

}



// WEBPACK FOOTER //
// ./src/services/account.js